export const getNavigatorLocale = () => {
    return navigator.language || 'en-US';
};
